import { useEffect } from "react";

import Loaders from "@/shared/components/loader";
import { LoginEndpoints } from "@/shared/models/endpoints/user-auth.endpoint";
import ENVIRONMENT_VAR from "@/shared/models/environment/environments.var";

function GoogleCallbackConnectApp() {
  const initAuthWithGoogle = () => {
    window.location.href = `${ENVIRONMENT_VAR.API_URL}${LoginEndpoints.LoggedUserGoogleRedirect}?fromApp=android`;
  };

  useEffect(() => {
    initAuthWithGoogle();
  }, []);

  return <Loaders />;
}

export default GoogleCallbackConnectApp;
